module.exports = __webpack_public_path__ + "img/VL_01_01.1ca08f1e.png";